export default __webpack_public_path__ + "static/media/pictogramTransfer40.99cd368e.svg";